// extracted by mini-css-extract-plugin
export default {"body":"list_body__PnyXJ","list":"list_list__XT0Ge"};